/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `GBP` - £
 * * `EUR` - €
 * * `USD` - $
 * * `RSD` - RSD
 */
export type Currency = typeof Currency[keyof typeof Currency];


export const Currency = {
  GBP: 'GBP',
  EUR: 'EUR',
  USD: 'USD',
  RSD: 'RSD',
} as const;
